module.exports = __webpack_public_path__ + "static/media/rc8.63e76a56.jpg";